/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RegimenInvestigation from './regimen-investigation';
import RegimenInvestigationDetail from './regimen-investigation-detail';
import RegimenInvestigationUpdate from './regimen-investigation-update';
import RegimenInvestigationDeleteDialog from './regimen-investigation-delete-dialog';

const RegimenInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RegimenInvestigation />} />
    <Route path="new" element={<RegimenInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenInvestigationDetail />} />
      <Route path="edit" element={<RegimenInvestigationUpdate />} />
      <Route path="delete" element={<RegimenInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenInvestigationRoutes;
